import { once } from 'lodash-es';

export const webpackPublicPathFactory = once(
    (rdcCdnUrl: string, environment: Environment, language: string) => {
        return environment === 'local' ? rdcCdnUrl : `${rdcCdnUrl}${language}/`;
    }
);
